
import React, {Component} from 'react'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {translate} from 'react-i18next'

import * as actions from '../../../actionTypes'
import * as constants from '../../../constants'

import {withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'

import moment from 'moment'
import DateOfBirthInput from '../../common/DateOfBirthInput'

import {isSessionDisabled} from '../../../selectors'

const styles = theme => ({
  fullWidth: {width: '80%'},
})

class DemographicsContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dateOfBirth: this.props.dateOfBirth,
      firstName: this.props.firstName,
      lastName: this.props.lastName,
      medicalRecordNumber: this.props.medicalRecordNumber,
      gender: this.props.gender,
      race: this.props.race,
      // Database storing string but api is returning boolean - turn bool value to string
      ethnicity: this.props.ethnicity.toString(),
      maritalStatus: this.props.maritalStatus,
      education: this.props.education,
      validDobForApi: this.isDobInputValueValidForApi(this.props.dateOfBirth),
    }

    this.amendNavigationPerDateOfBirth(this.props.dateOfBirth)
  }

  amendNavigationPerDateOfBirth = (dob) => {
    if (this.isDobInputValueValidForApi(dob)) {
      this.props.navigator.enableForward()
    } else {
      this.props.navigator.disableForward()
    }
  }

  handleChange(event) {
    const name = event.target.name
    const value = event.target.value

    const update = {[name]: value}

    if (name === 'dateOfBirth') {
      update.validDobForApi = this.isDobInputValueValidForApi(value)
      this.amendNavigationPerDateOfBirth(value)
    }

    this.setState(update, () => this.props.updateDemographics(this.state))
  }

  dynamicMenuItemDisplay = (stringArray, t) => {
    return stringArray.map((str) => {
      return (<MenuItem key={str} value={str}>{t(str)}</MenuItem>)
    })
  }

  // NOTE: API accepts valid moment OR a null value as an empty string
  isDobInputValueValidForApi = (dob) => {
    if (dob === '') {
      return true
    } else {
      return moment(dob, 'YYYY-MM-DD', true).isValid()
    }
  }

  render() {
    const {classes, t, isCounselingSessionDisabled} = this.props
    return (
      <Grid
        alignContent="flex-start"
        className="counseling-session-page-container"
        container
        justify="center"
        spacing={16}
        style={{marginBottom: 50}}
      >
        <Grid item xs={10}>
          <Typography variant="headline">{t('Participant Demographics')}</Typography>
        </Grid>

        <Grid item xs={10}>
          <TextField
            className={classes.fullWidth}
            id="demographics-first-name"
            label={t('First Name')}
            name='firstName'
            onChange={this.handleChange.bind(this)}
            value={this.state.firstName}
            disabled={isCounselingSessionDisabled}
          />
        </Grid>

        <Grid item xs={10}>
          <TextField
            className={classes.fullWidth}
            id="demographics-last-name"
            label={t('Last Name')}
            name='lastName'
            onChange={this.handleChange.bind(this)}
            value={this.state.lastName}
            disabled={isCounselingSessionDisabled}
          />
        </Grid>

        <Grid item xs={10}>
          <TextField
            className={classes.fullWidth}
            id="demographics-medical-record-number"
            label={t('Medical Record Number')}
            name='medicalRecordNumber'
            onChange={this.handleChange.bind(this)}
            value={this.state.medicalRecordNumber}
            disabled={isCounselingSessionDisabled}
          />
        </Grid>

        <Grid item xs={10}>
          <DateOfBirthInput
            className={classes.fullWidth}
            error={!this.state.validDobForApi}
            id="demographics-date-of-birth"
            label={t('Date of Birth')}
            name='dateOfBirth'
            onChange={this.handleChange.bind(this)}
            value={this.state.dateOfBirth}
            disabled={isCounselingSessionDisabled}
          />
        </Grid>

        <Grid item xs={10}>
          <FormControl className={classes.fullWidth}>
            <InputLabel htmlFor="gender">{t('Gender')}</InputLabel>
            <Select
              disabled={isCounselingSessionDisabled}
              value={this.state.gender}
              onChange={this.handleChange.bind(this)}
              inputProps={{
                name: 'gender',
                id: 'demographics-gender',
            }}
          >
              <MenuItem value={'M'}>{t('Male')}</MenuItem>
              <MenuItem value={'F'}>{t('Female')}</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={10}>
          <FormControl className={classes.fullWidth}>
            <InputLabel htmlFor="race">{t('Which Describes Racial Background')}</InputLabel>
            <Select
              disabled={isCounselingSessionDisabled}
              value={this.state.race}
              onChange={this.handleChange.bind(this)}
              inputProps={{
                name: 'race',
                id: 'demographics-race',
            }}
          >
              {this.dynamicMenuItemDisplay(constants.DEMOGRAPHICS.races, t)}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={10}>
          <FormControl className={classes.fullWidth}>
            <InputLabel htmlFor="ethnicity">{t('Are You Spanish')}</InputLabel>
            <Select
              disabled={isCounselingSessionDisabled}
              value={this.state.ethnicity}
              onChange={this.handleChange.bind(this)}
              inputProps={{
                name: 'ethnicity',
                id: 'demographics-ethnicity',
            }}
          >
              <MenuItem value="true">{t('Yes', {postProcess: 'yesOrNo'})}</MenuItem>
              <MenuItem value="false">{t('No', {postProcess: 'yesOrNo'})}</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={10}>
          <FormControl className={classes.fullWidth}>
            <InputLabel htmlFor="maritalStatus">{t('Marital Status')}</InputLabel>
            <Select
              disabled={isCounselingSessionDisabled}
              value={this.state.maritalStatus}
              onChange={this.handleChange.bind(this)}
              inputProps={{
                name: 'maritalStatus',
                id: 'demographics-marital-status',
            }}
          >
              {this.dynamicMenuItemDisplay(constants.DEMOGRAPHICS.maritalStatuses, t)}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={10}>
          <FormControl className={classes.fullWidth}>
            <InputLabel htmlFor="education">{t('What Is Your Highest Education')}</InputLabel>
            <Select
              disabled={isCounselingSessionDisabled}
              value={this.state.education}
              onChange={this.handleChange.bind(this)}
              inputProps={{
                name: 'education',
                id: 'demographics-education',
            }}
          >
            {this.dynamicMenuItemDisplay(constants.DEMOGRAPHICS.educations, t)}
            </Select>
          </FormControl>
        </Grid>

      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  dateOfBirth: state.counselingSession.counselingSessionData.dateOfBirth || '',
  firstName: state.counselingSession.counselingSessionData.firstName || '',
  lastName: state.counselingSession.counselingSessionData.lastName || '',
  medicalRecordNumber: state.counselingSession.counselingSessionData.medicalRecordNumber || '',
  gender: state.counselingSession.counselingSessionData.gender || '',
  race: state.counselingSession.counselingSessionData.race || '',
  ethnicity: state.counselingSession.counselingSessionData.ethnicity || '',
  maritalStatus: state.counselingSession.counselingSessionData.maritalStatus || '',
  education: state.counselingSession.counselingSessionData.education || '',
  isCounselingSessionDisabled: isSessionDisabled(state),
})

const mapDispatchToProps = dispatch => ({
  updateDemographics(demographics) {
    const action = {type: actions.UPDATE_DEMOGRAPHICS, payload: {demographics}}
    dispatch(action)
  },
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
  withStyles(styles)
)(DemographicsContainer)



// WEBPACK FOOTER //
// ./src/components/counseling-session/demographics/DemographicsContainer.js